import { InjectionToken } from '@angular/core';

// tree-expand æ§ä»¶å±å¼æ¶ç icon
export const UI_TREE_CHECKED_ICON = new InjectionToken<string>('UI_TREE_CHECKED_ICON');
// tree-expand æ§ä»¶æ¶èµ·æ¶ç icon
export const UI_TREE_UNCHECKED_ICON = new InjectionToken<string>('UI_TREE_UNCHECKED_ICON');

export const UI_TREE_DEPTH = new InjectionToken<number>('UI_TREE_DEPTH');
export const UI_TREE_OFFSET = new InjectionToken<number>('UI_TREE_OFFSET');